import { Fragment } from 'react'

import { SEO_SECTIONS, type SeoSegment } from './seoContent'
import { TextLink } from '../../../UiBlocks'

/**
 * SeoText — homepage editorial / SEO copy block (TSS-535)
 *
 * Thin renderer over ./seoContent (all copy + links live there as data).
 * HARDCODED, no admin. Rendered EAGERLY (plain markup, no fetch, no lazy) so
 * Googlebot's render pass picks it up. Lives at the BOTTOM of the homepage.
 * No FAQ on purpose — the user-intent editorial is more SEO-relevant than
 * generic shipping/warranty Q&A.
 */
const LINK_CLASS = 'inline-flex font-semibold text-text-color underline decoration-main-color decoration-2 underline-offset-4 hover:text-custom-red hover:decoration-custom-red'

function renderSegment(segment: SeoSegment, index: number) {
  if (typeof segment === 'string') {
    return <Fragment key={index}>{segment}</Fragment>
  }

  return (
    <TextLink
      key={index}
      href={segment.href}
      size="sm"
      className={LINK_CLASS}
    >
      {segment.text}
    </TextLink>
  )
}

export function SeoText() {
  return (
    <article className="mx-auto mt-4 w-full max-w-[1920px] px-1 pb-4 font-main-font text-text-color md:mt-6 md:px-6 xl:px-10">
      <div className="border border-border-color bg-white shadow-sm">
        <div className="border-b border-border-color bg-gradient-to-r from-white via-cards-bg to-white px-4 py-4 md:px-6 xl:px-8">
          <span className="mb-2 block text-xs font-semibold uppercase tracking-widest text-second-btn-bg">
            Ghid de cumpărare
          </span>
          <p className="max-w-5xl !text-xs !leading-relaxed !text-second-btn-bg md:!text-sm">
            Informații utile despre categoriile principale de scule, utilaje și echipamente disponibile în magazin.
          </p>
        </div>

        <div className="grid gap-5 px-4 py-5 md:px-6 md:py-6 xl:grid-cols-2 xl:gap-8 xl:px-8">
          {SEO_SECTIONS.map((section, sectionIndex) => (
            <section
              key={sectionIndex}
              className="border-l-2 border-main-color pl-4 md:pl-5"
            >
              <h2 className="mb-3 text-base font-bold leading-snug text-text-color md:text-lg">
                {section.heading}
              </h2>
              <div className="space-y-2.5 !text-xs !leading-relaxed !text-second-btn-bg md:!text-sm">
                {section.paragraphs.map((paragraph, paragraphIndex) => (
                  <p key={paragraphIndex} className="!text-xs !leading-relaxed !text-second-btn-bg md:!text-sm">
                    {paragraph.map(renderSegment)}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </article>
  )
}
